import { render } from "./AboutDevice.vue?vue&type=template&id=b768c2c0&scoped=true"
import script from "./AboutDevice.vue?vue&type=script&lang=js"
export * from "./AboutDevice.vue?vue&type=script&lang=js"

import "./AboutDevice.vue?vue&type=style&index=0&id=b768c2c0&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b768c2c0"]])

export default __exports__